module.exports = __webpack_public_path__ + "static/media/ubisoft-sun.30335592.svg";